export enum SidenavGroupId {
  MAIN = 'main',
  ORDER_DINING = 'order_dining',
  REPORTS_ANALYTICS = 'reports_analytics',
  MENU_PROMOTIONS = 'menu_promotions',
  SETTINGS_SUPPORT = 'settings_support'
}

export enum SidenavItemId {
  // Main
  HQ_DASHBOARD = 'hq_dashboard',
  ORDERS = 'orders',
  OUTLETS = 'outlets',
  BILLING = 'billing',
  
  // Order & Dining
  ORDER_DASHBOARD = 'order_dashboard',
  TABLE_SERVICE = 'table_service',
  TABLES = 'tables',
  TABLE_BOOKINGS = 'table_bookings',
  
  // Reports & Analytics
  REPORTS = 'reports',
  ANALYTICS = 'analytics',
  
  // Menu & Promotions
  MENU = 'menu',
  PROMOTIONS = 'promotions',
  
  // Settings & Support
  RESTAURANT_DETAILS = 'restaurant_details',
  STAFF_CENTER = 'staff_center',
  SETTLEMENT = 'settlement',
  E_INVOICE = 'e_invoice',
  INVENTORY = 'inventory',
  SECTIONS_COUNTERS = 'sections_counters',
  LOYALTY = 'loyalty',
  REFERRAL = 'referral',
  MARKETING = 'marketing',
  INTEGRATIONS = 'integrations',
  CUSTOMER_DISPALY='customer_dispaly',
  APP_SETTINGS = 'app_settings',
  OTHER_TOOL = 'other_tool',
  DEVICE_CENTER = 'device_center',
  HELP_CENTER = 'help_center'
}

export enum LockModalType {
  EXPIRED = 'expired',
  FREE_MENU_LEADS = 'free_menu_leads',
  FEATURE_UNAVAILABLE = 'feature_unavailable'
}

export enum UserType {
  HQ = 'HQ',
  POS = 'POS',
  KIOSK = 'KIOSK'
}

export enum SidenavEvent {
  ITEM_CLICKED = 'item_clicked',
  GROUP_TOGGLED = 'group_toggled',
  SIDEBAR_TOGGLED = 'sidebar_toggled',
  LOCK_TRIGGERED = 'lock_triggered'
} 